export const HostBackend = () => {
    return `/backend`;
}